module.exports = __webpack_public_path__ + "img/d.a07c3b57.jpg";